import TagManager from 'react-gtm-module';
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';

import { redactRumEvent } from './rumRedaction';

let gtmInitialized = false;
let dataDogInitialized = false;

const dataDogConfigDefaults = {
  DEFAULT_RUM_SAMPLERATE: 1,
  DEFAULT_RUM_REPLAY_SAMPLERATE: 0,
  DEFAULT_DD_SITE: 'datadoghq.eu',
};

export const initializeGTM = (config: {
  gtmId: string;
  auth?: string;
  preview?: string;
}) => {
  if (typeof window !== 'undefined' && config.gtmId && !gtmInitialized) {
    TagManager.initialize({
      gtmId: config.gtmId,
      auth: config.auth,
      preview: config.preview,
    });
    gtmInitialized = true;
  }
};

export const initializeDataDog = (config: {
  env: string;
  applicationId: string;
  clientToken: string;
  defaultPrivacyLevel: string;
  version: string;
  service: string;
  sampleRate?: string;
  replaySampleRate?: string;
}) => {
  if (
    typeof window !== 'undefined' &&
    config.applicationId &&
    !dataDogInitialized
  ) {
    const dataDogConfig = {
      env: config.env,
      applicationId: config.applicationId,
      clientToken: config.clientToken,
      defaultPrivacyLevel: config.defaultPrivacyLevel as DefaultPrivacyLevel,
      version: config.version,
      site: dataDogConfigDefaults.DEFAULT_DD_SITE,
      service: config.service,
      sessionSampleRate: config.sampleRate
        ? parseInt(config.sampleRate)
        : dataDogConfigDefaults.DEFAULT_RUM_SAMPLERATE,
      sessionReplaySampleRate: config.replaySampleRate
        ? parseInt(config.replaySampleRate)
        : dataDogConfigDefaults.DEFAULT_RUM_REPLAY_SAMPLERATE,
      enablePrivacyForActionName: true,
      beforeSend: redactRumEvent,
    };

    datadogRum.init(dataDogConfig);
    dataDogInitialized = true;
  }
};
